import React from "react";
import { useTranslation } from "react-i18next";
import { renderWithMobileBreaks } from "../utils/mobileBreaks";

const LANG_FLAG = { en: "EN", "zh-HK": "繁中·港", "zh-TW": "繁中·台", "zh-CN": "简中" };

export const EchoesGallery = () => {
  const { t } = useTranslation();
  const raw = t("echoes.samples", { returnObjects: true });
  const samples = Array.isArray(raw) ? raw : [];

  return (
    <section id="echoes" className="bg-[var(--bg-paper-deep)]/40 border-y border-[var(--rule)] py-24 md:py-32">
      <div className="max-w-6xl mx-auto px-6">
        <div className="max-w-2xl mb-14">
          <p className="text-[11px] uppercase tracking-[0.4em] text-[var(--wax)] mb-5">
            {t("echoes.kicker")}
          </p>
          <h2 className="font-display text-3xl md:text-4xl tracking-tight" data-testid="echoes-title">
            {t("echoes.title")}
          </h2>
          <p className="mt-4 text-[var(--ink-soft)] italic text-[17px]">
            {renderWithMobileBreaks(t("echoes.subtitle"))}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-testid="echoes-gallery">
          {samples.map((s, i) => {
            const isZh = (s.lang || "en").startsWith("zh");
            return (
              <article
                key={i}
                data-testid={`echo-card-${i}`}
                className="bg-[var(--bg-paper)] border border-[var(--rule)] p-7 md:p-8 shadow-[0_18px_40px_-22px_rgba(28,26,23,0.35)]"
              >
                <div className="flex items-start justify-between gap-3 mb-6">
                  <div className="text-[10px] uppercase tracking-[0.3em] text-[var(--wax)] leading-snug flex-1 min-w-0">
                    {s.tag || t("echoes.tag_default")}
                  </div>
                  <div className="text-[10px] uppercase tracking-[0.2em] text-[var(--ink-mute)] whitespace-nowrap shrink-0">
                    {LANG_FLAG[s.lang] || s.lang}
                  </div>
                </div>

                <p className={`${isZh ? "font-cn" : "font-en"} text-[14px] text-[var(--ink-mute)] italic mb-3`}>
                  — {s.name}
                </p>

                <div className="mb-7">
                  <p className="text-[9px] uppercase tracking-[0.32em] text-[var(--ink-soft)] mb-3">
                    {t("echoes.then_label")}
                  </p>
                  <blockquote
                    className={`${isZh ? "font-cn" : "font-en"} text-[15px] leading-[1.85] text-[var(--ink)] border-l-2 border-[var(--wax)] pl-4 italic`}
                    data-testid={`echo-then-${i}`}
                  >
                    {s.then}
                  </blockquote>
                </div>

                <div>
                  <p className="text-[9px] uppercase tracking-[0.32em] text-[var(--wax)] mb-3">
                    {t("echoes.now_label")}
                  </p>
                  <p
                    className={`${isZh ? "font-cn" : "font-en"} text-[15px] leading-[1.9] text-[var(--ink-soft)] whitespace-pre-line`}
                    data-testid={`echo-now-${i}`}
                  >
                    {s.now}
                  </p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
